import { render, staticRenderFns } from "./Ministries.vue?vue&type=template&id=ac24fab2&"
import script from "./Ministries.vue?vue&type=script&lang=js&"
export * from "./Ministries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports